import request from '@/api/base'

const selectRealEstateCertificatePage = (params, current, size) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/realEstateCertificate/selectRealEstateCertificatePage?current=' + current + '&size=' + size, params)
  } else {
    return request.post('/dcits-consumption/realEstateCertificate/selectRealEstateCertificatePage?current=' + current + '&size=' + size, params)
  }
}

const updateCertificate = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/realEstateCertificate/updateRealEstateCertificate', params)
  } else {
    return request.post('/dcits-consumption/realEstateCertificate/updateRealEstateCertificate', params)
  }
}
const addCertificate = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/realEstateCertificate/addRealEstateCertificate', params)
  } else {
    return request.post('/dcits-consumption/realEstateCertificate/addRealEstateCertificate', params)
  }
}

const delCertificate = (params, id) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/realEstateCertificate/delRealEstateCertificate?id=' + id, params)
  } else {
    return request.post('/dcits-consumption/realEstateCertificate/delRealEstateCertificate?id=' + id, params)
  }
}
const selectRealEstateCertificateList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/realEstateCertificate/selectRealEstateCertificateList', params)
  } else {
    return request.post('/dcits-consumption/realEstateCertificate/selectRealEstateCertificateList', params)
  }
}

export default {
  selectRealEstateCertificatePage,
  updateCertificate,
  addCertificate,
  delCertificate,
  selectRealEstateCertificateList
}



// WEBPACK FOOTER //
// ./src/area-contract/api/certificateService.js